import { render, staticRenderFns } from "./Cog.vue?vue&type=template&id=0dccab78"
import script from "./Cog.vue?vue&type=script&lang=js"
export * from "./Cog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports